import history from '../../containers/History'
import { handleOnNavClick as handleOnSingleReportNavClick } from '../../containers/ReportFile/module'
import { getSingleReport } from '../../store/appReducer'
import { ROUTES, CLEAR_STATE } from '../../constants'
// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'ReportsReport.'
export const UPDATE_SELECTED_REPORT_ID = `${PREFIX}UPDATE_SELECTED_REPORT_ID`

// ------------------------------------
// Actions
// ------------------------------------
export const updateSelectedReportId = id => ({
  type: UPDATE_SELECTED_REPORT_ID,
  payload: id,
})

export const setInitialReportsReportData = match => (dispatch, getState) => {
  const {
    reportId,
  } = match.params
  dispatch(updateSelectedReportId(reportId))
}

export const getReportsReportData = (forceUpdate = false) => (dispatch, getState) => {
  const {
    selectedReportId,
  } = getState().reportsReport

  return dispatch(getSingleReport(selectedReportId))
}

export const handleOnNavClick = reportId => (dispatch, getState) => {
  history.push(`${ROUTES.REPORTS_REPORT}/${reportId}`)
  dispatch(handleOnSingleReportNavClick())
}

const initialState = {
  selectedReportId: '',
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_SELECTED_REPORT_ID]: (state, action) => ({
    ...state, selectedReportId: action.payload,
  }),
  [CLEAR_STATE]: (state, action) => ({ ...initialState }),
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function reportsReportReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/legacy/pages/ReportsReport/module.js